/* eslint-disable no-loop-func */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/alt-text */
import React, {useState, useEffect, useMemo, useCallback} from 'react';
import css from '../../../styles/FacebookStatisticsTable.module.scss';
import classNames from 'classnames';
import {Link, useNavigate} from 'react-router-dom';
import imagePlug from '../../../_metronic/assets/media/user.png';
import {fieldsOfGroups, fieldsOfGroupsInf} from './customizationTable';
import {columns} from '../../pages/traffic/conversions/columns';
import {formatNumber, formatNumber2, formatNumberToCash} from '../../functions/formatNumber';
import {useResolvedThemeMode} from '../../hooks/useResolvedThemeMode';
import {useWindowWidth} from '../../hooks/useWindowWidth';

const Table = ({
  locationPathname,
  timeConfig,
  tableData,
  foundItems,
  columnsSettings,
  columnsId,
  presetData,
  loadingData,
  activeGroups,
  fieldToSortBy,
  groupsToSortBy,
  currentOpening,
  sort,
  open,
  close,
  setEditItemId,
  edit = null,
  fullMode = false,
  baseFields,
  branch,
  idForChangeSize,
}) => {
  const windowWidth = useWindowWidth();
  const themeMode = useResolvedThemeMode();
  const navigate = useNavigate();

  // Створення мапи для швидкого пошуку по compositeId
  const tableDataMap = useMemo(() => {
    const map = new Map();
    tableData.forEach((item) => map.set(item.compositeId, item));
    return map;
  }, [tableData]);

  // Функція перевірки, чи потрібно рендерити рядок, з використанням мапи
  const shouldRender = useCallback(
    (item) => {
      if (foundItems?.includes(item?.compositeId)) return true;
      let current = item;
      while (current.parentId) {
        const parent = tableDataMap.get(current.parentId);
        if (parent) {
          if (foundItems?.includes(parent.compositeId)) return true;
          current = parent;
        } else {
          break;
        }
      }
      return false;
    },
    [foundItems, tableDataMap]
  );

  // Мемоізоване фільтрування даних таблиці
  const filteredTableData = useMemo(() => {
    return tableData.filter((item) => {
      if (Array.isArray(foundItems) && !shouldRender(item)) return false;
      return true;
    });
  }, [tableData, foundItems, shouldRender]);

  // Функція для приховування колонок за налаштуваннями
  const hideColumns = useCallback((data, activeValues) => {
    return data
      .filter((item) => !activeValues.includes(item.value))
      .map((item) => ({
        ...item,
        subItems: item.subItems?.filter((sub) => !activeValues.includes(sub.value)) || [],
      }));
  }, []);

  // Отримання налаштувань колонок або завантаження їх із localStorage
  const effectiveColumnsSettings = useMemo(() => {
    if ('columns' in presetData && Array.isArray(presetData.columns)) return presetData.columns;

    if (columnsSettings.length > 0) return columnsSettings;

    try {
      return JSON.parse(localStorage.getItem(columnsId)) || [];
    } catch (error) {
      return [];
    }
  }, [columnsSettings, columnsId, presetData]);

  // Обчислення масиву колонок таблиці
  const computedColumns = useMemo(() => {
    const newColumns = hideColumns(structuredClone(baseFields), effectiveColumnsSettings);
    const groupMap = {};

    filteredTableData.forEach((item) => {
      if (!activeGroups.includes(item.group)) return;
      if (!groupMap[item.group]) {
        groupMap[item.group] = {value: item.group, isOpen: false, isOpenShow: false, sort: true};
      }
      if (item.isOpen) groupMap[item.group].isOpen = true;
      if (item.isOpenShow) groupMap[item.group].isOpenShow = true;
    });

    const groupedResult = activeGroups.map((group) => groupMap[group]).filter(Boolean);

    return [
      ...groupedResult.map((item) => ({
        ...(branch === 'inf'
          ? fieldsOfGroupsInf.find((el) => el.value === item.value)
          : fieldsOfGroups.find((el) => el.value === item.value)),
        ...item,
      })),
      ...newColumns,
    ];
  }, [filteredTableData, activeGroups, effectiveColumnsSettings, hideColumns]);

  // Функція для регулювання висоти таблиці
  const handleChangeTableWidth = useCallback(() => {
    const header = document.getElementById('kt_app_header');
    const filters = document.getElementById('table_filters');
    const toolbar = document.querySelector('.app-toolbar');
    const table = document.getElementById(`table_${locationPathname}`);

    if (windowWidth < 720) {
      table.style.maxHeight = `100dvh`;
      return;
    }

    if (filters) {
      table.style.maxHeight = `${
        window.innerHeight -
        (header?.getBoundingClientRect()?.height || 0) -
        (toolbar?.getBoundingClientRect()?.height || 0) -
        (filters?.getBoundingClientRect()?.height || 0) -
        (idForChangeSize && !fullMode
          ? document.getElementById(idForChangeSize)?.getBoundingClientRect()?.height
          : 0) -
        16 -
        (!fullMode ? 60 : 0)
      }px`;
    } else {
      table.style.maxHeight = `${
        window.innerHeight -
        (header?.getBoundingClientRect()?.height || 0) -
        (toolbar?.getBoundingClientRect()?.height || 0) -
        (idForChangeSize && !fullMode
          ? document.getElementById(idForChangeSize)?.getBoundingClientRect()?.height
          : 0) -
        (!fullMode ? 60 : 0)
      }px`;
    }
  }, [locationPathname, windowWidth, fullMode, idForChangeSize]);

  useEffect(() => {
    handleChangeTableWidth();
    window.addEventListener('resize', handleChangeTableWidth);
    return () => window.removeEventListener('resize', handleChangeTableWidth);
  }, [handleChangeTableWidth]);

  return (
    <div
      className={classNames(css.table__container, fullMode && css.table__container_full)}
      id={`table_${locationPathname}`}
      style={{
        '--bg': themeMode === 'dark' ? '#15171C' : '#FCFCFC',
        '--borderTable': themeMode === 'dark' ? 'rgba(30, 31, 36, 1)' : '#E4E4E5',
        '--bgRowTable': themeMode === 'dark' ? 'rgba(27, 29, 35, 1)' : 'rgba(245, 246, 247, 1)',
        '--bgRowTableActive':
          themeMode === 'dark' ? 'rgba(38, 41, 48, 1)' : 'rgba(229, 229, 229, 1)',
        '--bgRowTableHover':
          themeMode === 'dark' ? 'rgba(38, 41, 48, 1)' : 'rgba(229, 229, 229, 1)',
        '--closeColor': themeMode === 'dark' ? 'hsl(0, 0%, 80%)' : 'hsl(0, 0%, 20%)',
        height: '100%',
      }}
    >
      {loadingData && (
        <div className='progress' style={{height: 2}}>
          <div
            className={classNames(
              'progress-bar progress-bar-striped progress-bar-animated h-1',
              css.progressBar
            )}
            role='progressbar'
            style={{width: '100%'}}
          />
        </div>
      )}
      {!loadingData && (
        <table className={css.table}>
          <thead className={css.table__head}>
            <Header
              columns={computedColumns}
              fieldToSortBy={fieldToSortBy}
              groupsToSortBy={groupsToSortBy}
              sort={sort}
            />
          </thead>
          <Body
            timeConfig={timeConfig}
            columns={computedColumns}
            tableData={filteredTableData}
            foundItems={foundItems}
            activeGroups={activeGroups}
            edit={edit}
            open={open}
            close={close}
            currentOpening={currentOpening}
            setEditItemId={setEditItemId}
            navigate={navigate}
          />
        </table>
      )}
    </div>
  );
};

const formatWithCommasAndNoRounding = (value) => {
  const arr = String(value).split('.');

  if (arr[1] >= 2) {
    return `${arr[0]}.${arr[1][0]}${arr[1][1]}`;
  } else if (arr[1] === 1) {
    return `${arr[0]}.${arr[1][0]}0`;
  } else {
    return `${arr[0]}`;
  }
};

const Body = ({
  timeConfig,
  tableData,
  foundItems,
  columns,
  activeGroups,
  edit,
  open,
  close,
  currentOpening,
  setEditItemId,
}) => {
  const navigate = useNavigate();
  const [selectedRows, setSelectedRows] = useState([]);
  const [arrObjSelectedRows, setArrObjSelectedRows] = useState([]);

  // Використовуємо useEffect для оновлення обʼєктів вибраних рядків
  useEffect(() => {
    if (selectedRows.length === 0) return setArrObjSelectedRows([]);
    const resRows = [];
    selectedRows.forEach((id) => {
      tableData.forEach((obj) => {
        if (id === obj.compositeId) {
          resRows.push(obj);
        }
      });
    });
    setArrObjSelectedRows(resRows);
  }, [selectedRows, tableData]);

  return (
    <tbody>
      {tableData.map((item) => {
        // Якщо функція shouldRender повертає false – не відмальовуємо рядок

        const findIndexGroup = activeGroups.findIndex((group) => group === item?.group);

        return (
          <tr
            className={classNames(
              css.table__tr,
              selectedRows.includes(item.compositeId) && 'bg-light-warning'
            )}
            key={`${item?.compositeId}-${item?.parentId ? item?.parentId : 'p'}`}
            onClick={() => {
              const idx = selectedRows.findIndex((el) => el === item?.compositeId);
              if (idx === -1) {
                setSelectedRows((prev) => [...prev, item?.compositeId]);
              } else {
                const newSelectedRows = [...selectedRows];
                newSelectedRows.splice(idx, 1);
                setSelectedRows(newSelectedRows);
              }
            }}
          >
            {columns.map((col) => {
              if (col.subItems && col.subItems.length > 0) {
                // Якщо є subItems, відмальовуємо кожен з sub-полів
                return col.subItems.map((sub, subIndex) => {
                  const value = item[sub.value];
                  const type = sub.type;
                  return (
                    <td
                      className={classNames(
                        css.table__td,
                        css._isNotFixed,
                        css.isSub,
                        subIndex === col.subItems.length - 1 && css.cellEnd,
                        sub.fontWeight === 'bold' && 'fw-bold'
                      )}
                      style={{color: sub?.color, backgroundColor: sub?.subColor}}
                      key={`${item?.compositeId}-${item?.parentId ? item?.parentId : 'p'}-${
                        sub.value
                      }`}
                    >
                      <div
                        className={css.nameContainer}
                        style={
                          sub.colorForLess || sub.colorForMore
                            ? +value < 0
                              ? {color: `${sub.colorForLess}`}
                              : +value > 0
                              ? {color: `${sub.colorForMore}`}
                              : {}
                            : {}
                        }
                      >
                        {type === 'conversion' && (
                          <span>
                            {value === undefined || +value === 0
                              ? '-'
                              : `${formatNumber2(formatWithCommasAndNoRounding(value))}%`}
                          </span>
                        )}
                        {type === 'cash' && (
                          <span>
                            {value === undefined || +value === 0
                              ? '-'
                              : `${formatNumberToCash(formatWithCommasAndNoRounding(value))}`}
                          </span>
                        )}
                        {type === 'count' && (
                          <span>
                            {value === undefined || +value === 0
                              ? '-'
                              : `${formatNumber(formatWithCommasAndNoRounding(value))}`}
                          </span>
                        )}
                      </div>
                    </td>
                  );
                });
              } else {
                // Якщо немає subItems – це основне поле групи
                if (col.value === item.group) {
                  const getLinkUrl = () => {
                    if (!col.rout) {
                      return '';
                    }
                    let baseUrl = `${col.rout}${item.id}`;

                    if (!col.isTimeConfig) {
                      return baseUrl;
                    }

                    let queryString = '';

                    if (!!col.isFilter) {
                      queryString += `${item.group}_id=${item?.id}&`;
                    }
                    if (timeConfig?.time_config && timeConfig.time_config !== 'undefined') {
                      queryString += `time_config=${timeConfig.time_config}&`;
                    }
                    if (timeConfig?.time_start && timeConfig.time_start !== 'undefined') {
                      queryString += `time_start=${timeConfig.time_start}&`;
                    }
                    if (timeConfig?.time_end && timeConfig.time_end !== 'undefined') {
                      queryString += `time_end=${timeConfig.time_end}&`;
                    }
                    queryString = queryString.replace(/&$/, '');
                    return queryString ? `${baseUrl}?${queryString}` : baseUrl;
                  };

                  return (
                    <td
                      className={classNames(
                        css.table__td,
                        css.table__name,
                        col?.fontWeight === 'bold' && 'fw-bold',
                        selectedRows.includes(item.compositeId) && 'bg-light-warning'
                      )}
                      key={`${item?.compositeId}-${item?.parentId ? item?.parentId : 'p'}-${
                        col.value
                      }`}
                    >
                      <div className={classNames(css.name, css.nameContainer, css.nameForRows)}>
                        {col?.type === 'link' && !!col?.rout && (
                          <Link
                            to={getLinkUrl()}
                            target='_blank'
                            onClick={(e) => e.stopPropagation()}
                            style={{display: 'flex', gap: '10px', alignItems: 'center'}}
                          >
                            {'is_active' in item && item.is_active !== undefined ? (
                              <span
                                style={{
                                  width: '10px',
                                  height: '10px',
                                  borderRadius: '50%',
                                  backgroundColor: !!item.is_active ? '#34C77E' : '#FF3B30',
                                }}
                              ></span>
                            ) : (
                              <></>
                            )}
                            {item.id && item.name && item?.avatar ? (
                              <img
                                src={item?.avatar}
                                style={{
                                  width: '20px',
                                  height: '20px',
                                  objectFit: 'contain',
                                  borderRadius: '2px',
                                }}
                                onError={(e) => (e.target.src = imagePlug)}
                                alt='avatar'
                              />
                            ) : (
                              <></>
                            )}
                            <span
                              className='fw-bold text-gray-800'
                              style={
                                !item.name || !col?.rout
                                  ? {}
                                  : {
                                      textDecorationLine: 'underline',
                                      textDecorationStyle: 'dotted',
                                      textUnderlineOffset: '4px',
                                      cursor: 'pointer',
                                    }
                              }
                            >
                              {item?.name}
                            </span>
                            {edit === col?.edit && !item.parentId && (
                              <>
                                {!!col?.isEdit && (
                                  <div
                                    style={{padding: 4, pointerEvents: 'none'}}
                                    onClick={(e) => {
                                      e.preventDefault();
                                      e.stopPropagation();
                                      setEditItemId(item.id);
                                    }}
                                  >
                                    <i className='ki-duotone ki-pencil fs-7'>
                                      <span className='path1'></span>
                                      <span className='path2'></span>
                                    </i>
                                  </div>
                                )}
                                {!!col?.isEditLink && (
                                  <div
                                    style={{padding: 4, cursor: 'pointer'}}
                                    role='button'
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      navigate(`${col?.isEditLink}/${item.id}`);
                                      e.preventDefault();
                                    }}
                                  >
                                    <i className='ki-duotone ki-pencil fs-7'>
                                      <span className='path1'></span>
                                      <span className='path2'></span>
                                    </i>
                                  </div>
                                )}
                              </>
                            )}
                          </Link>
                        )}
                        {col?.type === 'link' && !col?.rout && (
                          <span style={{display: 'flex', gap: '10px', alignItems: 'center'}}>
                            {'is_active' in item && item.is_active !== undefined ? (
                              <span
                                style={{
                                  width: '10px',
                                  height: '10px',
                                  borderRadius: '50%',
                                  backgroundColor: !!item.is_active ? '#34C77E' : '#FF3B30',
                                }}
                              ></span>
                            ) : (
                              <></>
                            )}
                            {item.id && item.name && item?.avatar ? (
                              <img
                                src={item?.avatar}
                                style={{
                                  width: '20px',
                                  height: '20px',
                                  objectFit: 'contain',
                                  borderRadius: '2px',
                                }}
                                onError={(e) => (e.target.src = imagePlug)}
                                alt='avatar'
                              />
                            ) : (
                              <></>
                            )}
                            <span
                              className='fw-bold text-gray-800'
                              style={
                                !item.name || !col?.rout
                                  ? {}
                                  : {
                                      textDecorationLine: 'underline',
                                      textDecorationStyle: 'dotted',
                                      textUnderlineOffset: '4px',
                                      cursor: 'pointer',
                                    }
                              }
                            >
                              {item?.name}
                            </span>
                            {edit === col?.edit && !item.parentId && (
                              <>
                                {!!col?.isEdit && (
                                  <div
                                    style={{padding: 4}}
                                    role='button'
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      setEditItemId(item.id);
                                      e.preventDefault();
                                    }}
                                  >
                                    <i className='ki-duotone ki-pencil fs-7'>
                                      <span className='path1'></span>
                                      <span className='path2'></span>
                                    </i>
                                  </div>
                                )}
                                {!!col?.isEditLink && (
                                  <div
                                    style={{padding: 4, cursor: 'pointer'}}
                                    role='button'
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      navigate(`${col?.isEditLink}/${item.id}`);
                                      e.preventDefault();
                                    }}
                                  >
                                    <i className='ki-duotone ki-pencil fs-7'>
                                      <span className='path1'></span>
                                      <span className='path2'></span>
                                    </i>
                                  </div>
                                )}
                              </>
                            )}
                          </span>
                        )}
                        {item?.isExpandable && (
                          <>
                            {currentOpening === item?.compositeId ? (
                              <div
                                className={classNames(
                                  'spinner-border text-primary',
                                  css.table__openRow
                                )}
                                style={{width: 17, height: 17}}
                                role='status'
                              >
                                <span className='sr-only'>Loading...</span>
                              </div>
                            ) : (
                              <div
                                className={classNames(
                                  css.table__openRow,
                                  'd-flex align-items-center fs-1'
                                )}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  const id =
                                    item?.group === 'day' ||
                                    item?.group === 'month' ||
                                    item?.group === 'year' ||
                                    item?.group === 'app_type' ||
                                    item?.group === 'traffic_type'
                                      ? item?.name
                                      : item?.id;
                                  if (!item?.isOpen) {
                                    open(
                                      item?.group,
                                      id,
                                      item?.compositeId,
                                      activeGroups[findIndexGroup + 1]
                                    );
                                  } else {
                                    close(item?.compositeId, activeGroups[findIndexGroup + 1]);
                                  }
                                }}
                              >
                                {item?.isOpen ? '-' : '+'}
                              </div>
                            )}
                          </>
                        )}
                      </div>
                    </td>
                  );
                }
                return (
                  <td className={classNames(css.table__td, css.table__name)} key={col.value}></td>
                );
              }
            })}
          </tr>
        );
      })}
      {tableData.length === 0 && (
        <tr style={{width: '100%', height: 40}}>
          <td>
            <h6 className={classNames(css.emptyData, 'text-gray-600')}>Нет данных</h6>
          </td>
        </tr>
      )}
      {arrObjSelectedRows.length > 0 && tableData.length > 1 && (
        <Total
          tableData={arrObjSelectedRows}
          columns={columns}
          withParentId={false}
          setSelectedRows={setSelectedRows}
        />
      )}
      {tableData.length > 0 && <Total tableData={tableData} columns={columns} />}
    </tbody>
  );
};

const Total = ({tableData, columns, withParentId = true, setSelectedRows}) => {
  const [result, setResult] = useState({});

  useEffect(() => {
    // 🔹 Фільтрація даних, якщо з withParentId
    const filteredData = withParentId
      ? tableData.filter((item) => item.parentId === null)
      : tableData;

    const count_clicks = filteredData.reduce((acc, item) => acc + (item?.count_clicks || 0), 0);
    const count_leads = filteredData.reduce((acc, item) => acc + (item?.count_leads || 0), 0);
    const count_registrations = filteredData.reduce(
      (acc, item) => acc + (item?.count_registrations || 0),
      0
    );
    const count_qualifications = filteredData.reduce(
      (acc, item) => acc + (item?.count_qualifications || 0),
      0
    );
    const revenue_cpa = filteredData.reduce((acc, item) => acc + (item?.revenue_cpa || 0), 0);
    const count_appeals = filteredData.reduce((acc, item) => acc + (item?.count_appeals || 0), 0);
    const count_first_deposits = filteredData.reduce(
      (acc, item) => acc + (item?.count_first_deposits || 0),
      0
    );

    const cost = filteredData.reduce((acc, item) => acc + (item?.cost || 0), 0);
    const revenue = filteredData.reduce((acc, item) => acc + (item?.revenue || 0), 0);

    const revenue_rs = filteredData.reduce((acc, item) => acc + (item?.revenue_rs || 0), 0);
    const count_rs = filteredData.reduce((acc, item) => acc + (item?.count_rs || 0), 0);

    const safeDivide = (numerator, denominator) => {
      return denominator === 0 ? 0 : (numerator / denominator) * 100;
    };

    setResult({
      count_clicks,
      click2lead: safeDivide(count_leads, count_clicks),
      click2appeal: safeDivide(count_appeals, count_clicks),
      click2reg: safeDivide(count_registrations, count_clicks),
      click2fd: safeDivide(count_first_deposits, count_clicks),
      click2cpa: safeDivide(count_qualifications, count_clicks),
      click2rs: safeDivide(count_rs, count_clicks),
      cpc: safeDivide(cost, count_clicks) / 100,

      count_leads,
      lead2appeal: safeDivide(count_appeals, count_leads),
      lead2reg: safeDivide(count_registrations, count_leads),
      lead2fd: safeDivide(count_first_deposits, count_leads),
      lead2cpa: safeDivide(count_qualifications, count_leads),
      lead2rs: safeDivide(count_rs, count_leads),
      cpl: safeDivide(cost, count_leads) / 100,

      count_appeals,
      chat2reg: safeDivide(count_registrations, count_appeals),
      chat2fd: safeDivide(count_first_deposits, count_appeals),
      chat2cpa: safeDivide(count_qualifications, count_appeals),
      chat2rs: safeDivide(count_rs, count_appeals),
      cpm: safeDivide(cost, count_appeals) / 100,

      count_registrations,
      reg2fd: safeDivide(count_first_deposits, count_registrations),
      reg2cpa: safeDivide(count_qualifications, count_registrations),
      reg2rs: safeDivide(count_rs, count_registrations),
      cpr: safeDivide(cost, count_registrations) / 100,

      count_first_deposits,
      fd2cpa: safeDivide(count_qualifications, count_first_deposits),
      cpf: safeDivide(cost, count_first_deposits) / 100,

      count_qualifications,
      revenue_cpa,
      cpa: safeDivide(cost, count_qualifications) / 100,

      revenue_rs,
      count_rs,
      cprs: safeDivide(revenue_rs, count_rs) / 100,

      revenue,
      cost,
      profit: revenue - cost,
      romi: safeDivide(revenue - cost, cost),
    });
  }, [tableData, columns, withParentId]);

  const calcHeight = document.querySelector('.total')?.getBoundingClientRect()?.height;

  return (
    <tr
      className={classNames(css.table__tr, css.table__tr_total, !withParentId && 'total')}
      style={!withParentId ? {bottom: `${calcHeight}px`} : {}}
    >
      {columns.map((col, index) => {
        if (col.subItems && col.subItems.length > 0) {
          return col.subItems.map((sub, subIndex) => {
            const value = result?.[sub.value];
            const type = sub.type;

            return (
              <td
                key={`total-${col.value}-${sub.value}-${subIndex}`}
                className={classNames(
                  css.table__td,
                  css._isNotFixed,
                  css.isSub,
                  subIndex === col.subItems.length - 1 && css.cellEnd,
                  sub.fontWeight === 'bold' && 'fw-bold'
                )}
                style={{color: sub?.color, backgroundColor: sub?.subColor}}
              >
                <div
                  className={css.nameContainer}
                  style={
                    sub.colorForLess || sub.colorForMore
                      ? +value < 0
                        ? {color: `${sub.colorForLess}`}
                        : +value > 0
                        ? {color: `${sub.colorForMore}`}
                        : {}
                      : {}
                  }
                >
                  {type === 'conversion' && (
                    <span>
                      {value === undefined || +value === 0
                        ? '-'
                        : `${formatNumber2(formatWithCommasAndNoRounding(value))}%`}
                    </span>
                  )}
                  {type === 'cash' && (
                    <span>
                      {value === undefined || +value === 0
                        ? '-'
                        : `${formatNumberToCash(formatWithCommasAndNoRounding(value))}`}
                    </span>
                  )}
                  {type === 'count' && (
                    <span>
                      {value === undefined || +value === 0
                        ? '-'
                        : `${formatNumber(formatWithCommasAndNoRounding(value))}`}
                    </span>
                  )}
                </div>
              </td>
            );
          });
        } else {
          return (
            <React.Fragment key={`total-group-${col.value}-${index}`}>
              {!withParentId && (
                <td className={css.table__td}>
                  <div
                    style={{
                      width: '100%',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      gap: '10px',
                      padding: '0px 5px 0px 0px',
                    }}
                    onClick={() => setSelectedRows([])}
                  >
                    {index === 0 ? (
                      <>
                        <div className={classNames(css.nameContainer, css.nameForRows)}>
                          Выбрано
                        </div>
                        <div className={css.selectClose}></div>
                      </>
                    ) : null}
                  </div>
                </td>
              )}
              {withParentId && (
                <td
                  className={classNames(css.table__td, css.table__name, 'fw-bold')}
                  key={`total-label-${col.value}-${index}`}
                >
                  <div className={classNames(css.nameContainer, css.nameForRows)}>
                    {index === 0 ? 'Всего' : ''}
                  </div>
                </td>
              )}
            </React.Fragment>
          );
        }
      })}
    </tr>
  );
};

const Header = ({columns, setColumns, fieldToSortBy, groupsToSortBy, sort}) => {
  return (
    <React.Fragment>
      {/* Перший рядок заголовків */}
      <tr>
        {columns.map((cell) => {
          // Якщо є підзаголовки – встановлюємо colspan на кількість subItems
          if (cell.subItems && cell.subItems.length > 0) {
            return (
              <th
                className={classNames(css.table__th, css.headGroup)}
                key={cell.value}
                colSpan={cell.subItems.length}
              >
                <div
                  className={classNames(css.nameContainer)}
                  style={{display: 'flex', alignItems: 'center'}}
                >
                  {cell.marker && (
                    <span className={css.marker} style={{backgroundColor: `${cell.marker}`}}></span>
                  )}
                  <span className='text-gray-500'>{cell.label}</span>
                </div>
              </th>
            );
          }
          // Якщо підзаголовків немає – клітинка займає два рядки
          const findSortedGroup = groupsToSortBy.find((item) => item.group === cell.value);
          return (
            <th
              className={classNames(css.table__th, css.table__th_head)}
              key={cell.value}
              rowSpan={2}
            >
              <div
                className={classNames(css.nameContainer, cell?.sort && css.nameSortable)}
                data-title={cell?.clue}
                title={cell?.clue}
                style={{display: 'flex', alignItems: 'center'}}
                onClick={() => {
                  if (cell.isNotSorted) return;
                  sort(
                    !findSortedGroup || findSortedGroup?.sortOrder === 'desc' ? 'asc' : 'desc',
                    'id',
                    cell?.value
                  );
                }}
              >
                <span className='text-gray-500'>{cell.label}</span>
                {cell.sort && !cell.isNotSorted && (
                  <span
                    className={classNames(
                      css.sort,
                      !!findSortedGroup && findSortedGroup?.sortOrder === 'asc' && css._active
                    )}
                  ></span>
                )}
              </div>
            </th>
          );
        })}
      </tr>

      {/* Другий рядок заголовків – тільки для елементів з subItems */}
      <tr>
        {columns.map((cell) => {
          if (cell.subItems && cell.subItems.length > 0) {
            return cell.subItems.map((subCell, subIndex) => (
              <th
                className={classNames(
                  css.table__th,
                  subIndex === 0 && css.headGroup__start,
                  subIndex === cell.subItems.length - 1 && css.headGroup__end
                )}
                key={subCell.value}
                title={subCell.clue || ''}
              >
                <div
                  className={classNames(css.nameContainer, subCell.sort && css.nameSortable)}
                  style={{display: 'flex', alignItems: 'center'}}
                  onClick={() =>
                    sort(
                      fieldToSortBy?.sortOrder === 'asc' &&
                        fieldToSortBy?.sortField === subCell.value
                        ? 'desc'
                        : 'asc',
                      subCell.value,
                      null
                    )
                  }
                >
                  <span className='text-gray-500'>{subCell.label}</span>
                  {subCell.sort && (
                    <span
                      className={classNames(
                        css.sort,
                        fieldToSortBy?.sortOrder === 'asc' &&
                          fieldToSortBy?.sortField === subCell?.value &&
                          css._active
                      )}
                    >
                      {/* {console.log(subCell)} */}
                    </span>
                  )}
                </div>
              </th>
            ));
          }
          return null;
        })}
      </tr>
    </React.Fragment>
  );
};

export default Table;
